import { fixResponseJSON } from "../assets/helpers/funciones";
let url = process.env.REACT_APP_API_URL;

export const refundService = {
  createRefund: async (data) => {
    const myInit = {
      headers: {
        "x-api-key": process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      method: "POST",
      body: data,
    };

    const response = await fetch(`${url}/refund/create`, myInit)
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
};
